import styled, { css } from 'styled-components';
import { color, size } from './helpers/variables';

export const MainProductImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  float: ${props => (props.swipe ? 'left' : 'none')};
  padding-bottom: 100%;

  display: block;
  margin: ${props => (props.small ? '0 0 .5rem' : '0 0 2rem')};

  padding-left: ${props =>
    props.swipe ? `calc(8px + ((80 - 8) * ((100vw - ${size.small}px) / (${size.large} - ${size.small}))))` : '0'};
  padding-right: ${props =>
    props.swipe ? `calc(8px + ((80 - 8) * ((100vw - ${size.small}px) / (${size.large} - ${size.small}))))` : '0'};

  background-color: #fff;
  border: 1px solid transparent;
  
  ${props =>
    props.insideList &&
    css`
      margin: 0;
    `}
  
  ${props =>
    props.swipe &&
    css`
      margin: 0;
    `}

  ${props =>
    props.selected &&
    css`
      border: 1px solid ${color.primary};
    `}
`;

export const MainProductImageContent = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 2rem 0.5rem 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: ${size.medium}px) {
    padding: 2rem 1rem 0.75rem;
  }

  @media (min-width: ${size.large}px) {
    padding: 3rem 1.75rem;
  }

  ${props =>
    props.small &&
    css`
      padding: 8px !important;
    `};
`;



// WEBPACK FOOTER //
// ./src/styles/MainProductImage.js